import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

import Layout from '../views/Layout.vue';
import Login from '../views/Login.vue';

const routes = [
  { path: '/login', name: 'Login', component: Login },
  {
    path: '/',
    component: Layout,
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('../views/Dashboard.vue') },
      { path: 'bloggers', name: 'BloggerList', component: () => import('../views/BloggerList.vue') },
      { path: 'bloggers/:id', name: 'BloggerDetail', component: () => import('../views/BloggerDetail.vue') },
      { path: 'users', name: 'UserList', component: () => import('../views/UserList.vue') },
      { path: 'resources', name: 'ResourceList', component: () => import('../views/ResourceList.vue') },
      { path: 'withdraw', name: 'WithdrawPending', component: () => import('../views/WithdrawPending.vue') },
      { path: 'withdraw/history', name: 'WithdrawHistory', component: () => import('../views/WithdrawHistory.vue') },
      { path: 'settings', name: 'Settings', component: () => import('../views/Settings.vue') },
      { path: '', redirect: '/dashboard' }
    ]
  }
];

const router = new VueRouter({ mode: 'hash', routes });

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !store.state.token) {
    next({ name: 'Login' });
  } else {
    next();
  }
});

export default router;
